module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subscription/subscription.component.css
// module id = ./src/app/subscription/subscription.component.css
// module chunks = main